/**
 * @generated SignedSource<<761d2e86bb6e90040aaca58138d4a64e>>
 * @relayHash 7e377d65a9bf5b57a7ab284371bf9a2b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2f68893d561ef8c143ece1a9cb3c527fe8c6c6fa2c44d57135a7193d9f74417

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassicPortalSettingsQuery$variables = {
  cloudId: string;
};
export type ClassicPortalSettingsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PortalSettings">;
};
export type ClassicPortalSettingsQuery = {
  response: ClassicPortalSettingsQuery$data;
  variables: ClassicPortalSettingsQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider: {
    readonly get: () => boolean;
  };
});

import rovoAgentConfigExperienceFG_provider from '@atlassian/jira-relay-provider/src/jsm-portal-rovo-agent-config-experience.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyEditableAgents": true
    }
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ClassicPortalSettingsQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PortalSettings"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ClassicPortalSettingsQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              },
              {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "externalConfigReference"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "identityAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "creatorType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              }
            ]
          },
          {
            "args": (v2/*: any*/),
            "filters": [
              "cloudId",
              "input"
            ],
            "handle": "connection",
            "key": "RovoAgent_agentStudio_getAgents",
            "kind": "LinkedHandle",
            "name": "agentStudio_getAgents"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a2f68893d561ef8c143ece1a9cb3c527fe8c6c6fa2c44d57135a7193d9f74417",
    "metadata": {},
    "name": "ClassicPortalSettingsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider
    }
  }
};
})();

(node as any).hash = "08e5ce8c4a6305e99f7dfc76d1135666";

export default node;
